import { AbstractControl, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';

export class AddBillerForm extends FormGroup {
  constructor() {
    super({
      biller: new FormControl('', [Validators.required, billerNameValidator]),
    });
  }

  get biller(): FormControl {
    return this.get('biller') as FormControl;
  }
}

function billerNameValidator(control: AbstractControl): ValidationErrors | null {
  return control.value?.name?.trim().length > 0 ? null : { billerName: true };
}
